var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "700" },
          model: {
            value: _vm.modal,
            callback: function ($$v) {
              _vm.modal = $$v
            },
            expression: "modal",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "primary white--text",
                  class: {
                    headline: !_vm.isMobilePort,
                    "caption mobile-title": _vm.isMobilePort,
                  },
                },
                [
                  _vm.isUpdate
                    ? _c("span", [_vm._v("Edit Note / Bookmark")])
                    : _c("span", [_vm._v("Add Note / Bookmark")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "primary white--text",
                      on: { click: _vm.closeModal },
                    },
                    [_vm._v("close")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "inner-modal-content" },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { staticClass: "font-weight-bold pb-0" }, [
                        _vm._v(
                          "\n                        Note (optional)\n                    "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                value: _vm.selectionTruncated,
                                color: "error",
                                icon: "warning",
                                outlined: "",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            The note you are creating will only apply to the active section and although highlighted\n                            text may expand outside of this section the highlight will only apply to text within\n                            that section once the note is saved.\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("vue-editor", {
                            attrs: { "editor-toolbar": _vm.customToolbar },
                            model: {
                              value: _vm.editorData,
                              callback: function ($$v) {
                                _vm.editorData = $$v
                              },
                              expression: "editorData",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { align: "center" } },
                    [
                      !_vm.loadingTags
                        ? [
                            _c(
                              "v-col",
                              [
                                _c("v-autocomplete", {
                                  ref: "projectTag",
                                  attrs: {
                                    items: _vm.tags,
                                    "item-text": "tag",
                                    "item-value": "id",
                                    chips: "",
                                    "small-chips": "",
                                    dense: "",
                                    outlined: "",
                                    label: "Project Tag",
                                    rules: [
                                      (v) => !!v || "Project tag is required",
                                    ],
                                    "hide-details": "auto",
                                  },
                                  model: {
                                    value: _vm.selectedTag,
                                    callback: function ($$v) {
                                      _vm.selectedTag = $$v
                                    },
                                    expression: "selectedTag",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { sm: "auto" } },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "auto" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          disabled: _vm.selectedTag === 1,
                                          outlined: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.createNewTagModal(
                                              true,
                                              _vm.selectedTag
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Edit Tag\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { outlined: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.createNewTagModal(
                                              false,
                                              _vm.selectedTag
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    Add Tag\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : [
                            _c(
                              "v-col",
                              [
                                _c("v-progress-linear", {
                                  attrs: { indeterminate: true },
                                }),
                              ],
                              1
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.activeEnterpriseProfile
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.visibilityItems,
                                  label: "Visibility",
                                  outlined: "",
                                  flat: "",
                                  "hide-details": "",
                                  dense: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "selection",
                                      fn: function ({ item }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-2" },
                                            [_vm._v(_vm._s(item.icon))]
                                          ),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.text) +
                                              "\n                            "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item",
                                      fn: function ({ item }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            { staticClass: "mr-2" },
                                            [_vm._v(_vm._s(item.icon))]
                                          ),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(item.text) +
                                              "\n                            "
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3449852572
                                ),
                                model: {
                                  value: _vm.selectedVisibility,
                                  callback: function ($$v) {
                                    _vm.selectedVisibility = $$v
                                  },
                                  expression: "selectedVisibility",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { text: "" }, on: { click: _vm.closeModal } },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", loading: _vm.isSaving },
                      on: { click: _vm.saveNote },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.removeModal,
            callback: function ($$v) {
              _vm.removeModal = $$v
            },
            expression: "removeModal",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "primary white--text",
                  class: {
                    headline: !_vm.isMobilePort,
                    "caption mobile-title": _vm.isMobilePort,
                  },
                },
                [
                  _vm._v(
                    "\n                Delete Note / Bookmark\n                "
                  ),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-icon",
                    {
                      staticClass: "primary white--text",
                      on: {
                        click: function ($event) {
                          _vm.removeModal = false
                        },
                      },
                    },
                    [_vm._v("close")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { staticClass: "text-center" }, [
                        _vm.isEnterpriseAdminAction()
                          ? _c("p", { staticClass: "mb-0 mt-5" }, [
                              _vm._v(
                                "\n                            Are you sure you want to delete this public note from " +
                                  _vm._s(_vm.getNoteCreatorName()) +
                                  "? It will be removed for everyone in your Enterprise.\n                        "
                              ),
                            ])
                          : _c("p", { staticClass: "mb-0 mt-5" }, [
                              _vm._v(
                                "\n                            Are you sure you want to remove this note?\n                        "
                              ),
                            ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.removeModal = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", loading: _vm.isDeleting },
                      on: { click: _vm.deleteNote },
                    },
                    [_vm._v("Delete")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "400" },
          model: {
            value: _vm.invalidNoteUrl,
            callback: function ($$v) {
              _vm.invalidNoteUrl = $$v
            },
            expression: "invalidNoteUrl",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Invalid URL"),
              ]),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(
                  "\n                Your note contains an Invalid URL?\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", flat: "" },
                      on: {
                        click: function ($event) {
                          _vm.invalidNoteUrl = false
                        },
                      },
                    },
                    [_vm._v("Ok")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }